<div class="bg-white custom-table rounded p-2 mb-3">
  <div class="mt-2">
    <app-current-events
      [asset]="asset"
      [isPageTemporary]="isPageTemporary"
      [isAssetDetailsPage]="false"
    />
  </div>
  <app-historical-events [asset]="asset" />
</div>
